import { useState, useEffect } from "react";
import "./LoginPage.css";
import banner from "../../images/cycle1.png";
import { useNavigate } from "react-router-dom";

const LoginPage = () => {
  const [formData, setFormData] = useState({
    userName: "",
    userPassword: "",
  });
  const [error, setError] = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const navigate = useNavigate();

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsLoading(true);
    setError(null);

    try {
      const response = await fetch("/authenticate", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          userName: formData.userName.toLowerCase(),
          userPassword: formData.userPassword,
        }),
      });

      if (response.ok) {
        const data = await response.json();

        const oldToken = sessionStorage.getItem("jwtToken");
        if (oldToken) {
          await fetch("/expire-token", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ token: oldToken }),
          });
          sessionStorage.clear();
        }

        sessionStorage.setItem("jwtToken", data.jwtToken);
        sessionStorage.setItem("employeeID", data.user.employeeID);
        sessionStorage.setItem("roleName", data.user.role[0].roleName);
        setIsAuthenticated(true);
      } else {
        setError("Incorrect username or password");
      }
    } catch (error) {
      console.error(error);
      setError("Something went wrong. Please try again.");
    }

    setIsLoading(false);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch("/enduser", {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("jwtToken")}`,
          },
        });

        if (response.ok) {
          const roleName = sessionStorage.getItem("roleName");
          const employeeID = sessionStorage.getItem("employeeID");
          const jwtToken = sessionStorage.getItem("jwtToken");
          if (roleName === "User") {
            sessionStorage.setItem("userEmployeeID", employeeID);
          } else if (roleName === "Admin") {
            sessionStorage.setItem("adminEmployeeID", employeeID);
          } else {
            navigate(`/error`);
          }

          navigate(`/Dashboard`);
        } else {
          console.log("Error: ", response.status);
        }
      } catch (error) {
        console.error(error);
      }
    };

    if (isAuthenticated) {
      fetchData();
    }
  }, [isAuthenticated, navigate]);

  return (
    <div className="login-wrapper">
      <div className="login-left">
        <div className="login-content">
          <h2>Sign in to your account</h2>
          <p className="sub-text">Welcome back! Please enter your details.</p>
          <form onSubmit={handleSubmit}>
            <input
              type="email"
              name="userName"
              placeholder="Email address"
              required
              value={formData.userName}
              onChange={handleInputChange}
            />
            <input
              type="password"
              name="userPassword"
              placeholder="Password"
              required
              value={formData.userPassword}
              onChange={handleInputChange}
            />
            {/* <div className="options">
              <a href="#">Forgot password?</a>
            </div> */}
            <button className="btnss" type="submit">
              Login
            </button>
            {/* <p className="signup-link">
              Don’t have an account? <a href="#">Sign up</a>
            </p> */}
          </form>
        </div>
      </div>
      <div className="login-right">
        <img src={banner} alt="Visual" />
      </div>
    </div>
  );
};

export default LoginPage;
